import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const aktivitasFaModule = () => import('./aktivitas-fa.module').then((m) => m.AktivitasFaModule);

export const aktivitasFaRoutes: Routes = [
  {
    path: 'aktivitas-fa',
    canActivateChild: [RoleGuard],
    loadChildren: aktivitasFaModule,
    data: {
      enum: 'ACTIVITY_FA',
      label: 'Aktivitas FA',
      icon: 'ic_field_assistant.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'ACTIVITY_LIST',
          label: 'List Aktivitas',
          path: 'aktivitas-fa/fa/list',
          children: [],
        },
        {
          enum: 'BUDGET_DISBURSEMENT',
          label: 'Pencairan Budget',
          path: 'aktivitas-fa/pencairan-budget/list',
          children: [],
        },
        {
          enum: 'LPJ_ACTIVITY',
          label: 'LPJ Aktivitas',
          path: 'aktivitas-fa/lpj',
          children: [],
        },
      ],
    },
  },
];
